export enum AnexoEnum {
  DOCUMENTO = 'DOCUMENTO',
  VIDEO = 'VIDEO',
}

export type AnexoPautaType = {
  descricao: string;
  dataCadastro?: string | null | undefined;
  file?: File;
  flgDisponivelAssociado?: boolean;
  tipoAnexo: AnexoEnum;
  url?: string;
  oidAnexoPauta?: number;
  idTemporarioFront?: number;
  nomDocumento?: string;
};
